export default {"src":"/_next/static/media/minus-outline.7535dd48.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};